"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var from_1 = require("rxjs/observable/from");
var operators_1 = require("rxjs/operators");
/**
 * @author gevorg.avetisyan on 11/29/2017.
 */
var CalculationServiceImpl = /** @class */ (function () {
    function CalculationServiceImpl(http, applicationPropertiesService, classifierService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.classifierService = classifierService;
        this.meServiceUriKey = "me-de-service-url";
        this.calculationUriKey = "calculation-report-url";
        this.meServiceUri$ = from_1.from(this.applicationPropertiesService.getProperty(this.meServiceUriKey));
    }
    CalculationServiceImpl.prototype.getIndicatorCalculatedDataRequest = function (masterId, body, showDisaggregation) {
        var _this = this;
        return Observable_1.Observable.combineLatest(this.meServiceUri$, this.getCalculationReport())
            .pipe(operators_1.switchMap(function (data) {
            data[1].report.options.showIndicatorDisaggregations = showDisaggregation;
            body["filter"] = data[1].filters;
            body["indicatorId"] = parseInt(body.indicatorId);
            body["insertedData"] = body["insertedData"] || {};
            body["updatedData"] = body["updatedData"] || {};
            body["deletedData"] = body["deletedData"] || {};
            body["dataSetId"] = data[1].dataSetId;
            body["reportState"] = JSON.stringify(data[1].report);
            body.filter.children[0].values.push(body.indicatorId);
            body.filter.children[1].values.push(masterId);
            return _this.http.put(data[0] + "indicator/" + body.indicatorId + "/calculate/" + masterId, body);
        }));
    };
    CalculationServiceImpl.prototype.getCalculationReport = function () {
        var _this = this;
        return from_1.from(this.applicationPropertiesService.getProperty(this.calculationUriKey)).pipe(operators_1.switchMap(function (url) { return _this.http.get(url); }));
    };
    CalculationServiceImpl = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_classifier_service_client_js_1.ClassifierService])
    ], CalculationServiceImpl);
    return CalculationServiceImpl;
}());
exports.CalculationServiceImpl = CalculationServiceImpl;
//# sourceMappingURL=calculation.service.js.map